<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1; display: flex; align-items: center">
        <el-radio-group
          v-model="state.params.DdLx"
          style="margin-right: 10px"
          @change="onDdLxChange"
        >
          <el-radio-button :label="0">全部</el-radio-button>
          <el-radio-button :label="1">旅游订单</el-radio-button>
          <el-radio-button :label="2">商品订单</el-radio-button>
        </el-radio-group>
        <el-input
          v-model="state.params.Key"
          style="width: 15%; margin-right: 10px"
          :placeholder="state.params.DdLx == 2 ? '订单编号、商品名称' : '退款单号、订单编号、订单名称'"
          clearable
          @clear="
            delete state.params.Key;
            onLoad();
          "
        ></el-input>
        <el-radio-group
          v-if="state.params.DdLx != 2"
          v-model="state.params.IsCheck"
          style="margin-right: 10px"
          @change="onLoad()"
        >
          <el-radio-button>全部</el-radio-button>
          <el-radio-button :label="true">已审核</el-radio-button>
          <el-radio-button :label="false">待审核</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-model="state.params.Ftsjs"
          type="daterange"
          :start-placeholder="state.params.DdLx == 1 ? '--发团开始时间--' : '--下单开始时间--'"
          :end-placeholder="state.params.DdLx == 1 ? '--发团截止时间--' : '--下单截止时间--'"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD 00:00:00"
          style="flex-grow: unset"
        />
        <el-dropdown
          split-button
          @click="onLoad"
          type="primary"
          style="margin: 0 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="DdLxText"
          label="订单类型"
          width="100"
          align="center"
        >
          <template #default="{ row }">
            <el-tag :type="row.DdLx == 1 ? '' : 'success'" size="small">
              {{ row.DdLxText }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="DdLyText"
          label="订单来源"
          width="110"
          align="center"
        >
          <template #default="{ row }">
            <span v-if="row.DdLyText">{{ row.DdLyText }}</span>
            <span v-else style="color: #ccc">-</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable="Bh"
          label="状态/退款单号"
          :formatter="
            (row) => $tab_GroupFormat(row.ZtText, row.Bh, row.ZtColor)
          "
        />
        <el-table-column
          prop="DdBh"
          sortable="DdBh"
          label="订单编号"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="DdMc"
          sortable="DdMc"
          label="订单名称"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="Je"
          sortable="Je"
          label="退款金额"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column
          prop="Bz"
          label="退款备注"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="TkSj"
          sortable="TkSj"
          label="退款时间"
          width="170"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="操作"
          width="100"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Operation"
              link
              v-if="row.ShowCheck"
              @click="
                state.selectId = row.Id;
                state.showCheck = true;
              "
              >审核
            </el-button>
            <el-button
              type="primary"
              :icon="Search"
              link
              v-else-if="row.DdLx == 1"
              @click="
                state.selectId = row.Id;
                state.showDetail = true;
              "
              >查看
            </el-button>
            <span v-else style="color: #999; font-size: 12px">已退款</span>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.PageIndex"
      @onLoad="
        (pageIndex) => {
          state.params.PageIndex = pageIndex;
          onLoad();
        }
      "
    >
    </c_page>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showCheck"
        title="退款审核"
        @close="state.showCheck = false"
      >
        <c_LvYouDingDanTuiKuanCheck
          @close="
            state.showCheck = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_LvYouDingDanTuiKuanCheck>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showDetail"
        title="退款单详情"
        @close="state.showDetail = false"
      >
        <c_LvYouDingDanTuiKuanDetail
          :id="state.selectId"
        ></c_LvYouDingDanTuiKuanDetail>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  shangpindingdan_gettuikuanpage,
} from "@/http/api";
import { useRouter } from "vue-router";

class InitFormData {
  params = {
    PageSize: 20,
    PageIndex: 1,
    DdLx: 0,
    IsCheck: false,
    Order: "Cjsj",
    Asc: false,
  };
}

export default {
  components: {},
  setup() {
    const router = useRouter();
    const state = reactive(new InitFormData());

    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      const queryParams = {
        pageIndex: state.params.PageIndex,
        pageSize: state.params.PageSize,
        ddLx: state.params.DdLx,
        key: state.params.Key || undefined,
        isCheck: state.params.DdLx == 2 ? undefined : state.params.IsCheck,
        startTime: state.params.Ftsjs?.[0] || undefined,
        endTime: state.params.Ftsjs?.[1] || undefined,
      };
      shangpindingdan_gettuikuanpage(queryParams).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    // 订单类型切换
    const onDdLxChange = () => {
      state.params.PageIndex = 1;
      delete state.params.Key;
      delete state.params.Ftsjs;
      state.params.IsCheck = false;
      onLoad();
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.Order = column.sortable;
        state.params.Asc = column.order === "ascending";
      } else {
        const { params } = new InitFormData();
        state.params.Order = params.Order;
        state.params.Asc = params.Asc;
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoad,
      onDdLxChange,
      onSortChange,
      onReset,
      router,
    };
  },
};
</script>
<style lang="less" scoped>
.drawerCss {
  width: 40vw !important;
}

.drawerCss > div {
  overflow: hidden;
  padding: 0 !important;
}
</style>
